
export function pad( string: string, length: number = 2, char: string = "0") {
  while( string.length < length ) {
    string = char + string
  }

  return string
}